import { AccountStatus } from '@finch-api/common/dist/external/dashboard/connection-status';
import { Connection } from '../../model';
import dayjs from 'dayjs';

export const connectionsNeedAttention = (connections: Connection[]): number => {
  const needsAttention = [
    AccountStatus.ERROR_NO_ACCOUNT_SETUP,
    AccountStatus.ERROR_PERMISSIONS,
    AccountStatus.REAUTH,
  ];
  return connections.filter((conn) =>
    needsAttention.includes(conn.connectionStatus),
  ).length;
};

export const connectionsSyncingFailures = (
  connections: Connection[],
): number => {
  return connections.filter(
    (conn) =>
      conn.isConnected() &&
      conn.isAutomated() &&
      dayjs(conn.lastSyncAt).isBefore(dayjs().subtract(3, 'days')),
  ).length;
};
